<template>
  <div class="addInvoice-con">
    <div class="addInvoice-main">
      <div class="addInvoice-title">
        {{ popupTitle }}
        <img @click="closePopup" class="popup-close" src="https://resource.rcclchina.com.cn/invoice/popupClose-icon.png" alt="">
      </div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "InvoicePopup",
  props: {
    popupTitle: {
      type: String,
      default: ''
    },
  },
  methods: {
    closePopup () {
      this.$emit('closePopup')
    }
  }
}
</script>
<style scoped lang="less">
.addInvoice-con {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;

  .addInvoice-main {
    width: 802px;
    position: absolute;
    background: #fff;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding-bottom: 30px;

    .addInvoice-title {
      font-size: 17px;
      font-weight: bold;
      color: #333333;
      text-align: center;
      padding: 25px 0;
      border-bottom: 1px solid #d9d9d9;
      position: relative;
      .popup-close {
        width: 25px;
        height: 25px;
        position: absolute;
        padding: 5px;
        right: 14px;
        top: 14px;
        cursor: pointer;
      }
    }
  }
}
</style>